import React from "react";
import { useState } from "react";
import ReactQuill from "react-quill";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addTermsCondition } from "../../actions";

const TermsAddTab = () => {

  const dispatch = useDispatch()
  const [terms, setTerms] = useState()

  const onChange = (value) => {
    setTerms(value)
  }

  const onSave = () => {
    const payload = {
      data: terms
    }
    dispatch(addTermsCondition(payload))
    alert('Added')
  }

  console.log("termsterms", terms);
  return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Terms & conditions</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/terms">
                        <i className="feather icon-home"></i>{" "}
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Terms & conditions</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                  <div className="">
                      <ReactQuill
                        value={terms}
                        onChange={onChange}
                      />
                      <br />
                      <br />{" "}
                      <div className="row float-right p-3">
                       
                          <button
                            onClick={onSave}
                            className="btn btn-grd-disabled mr-2"
                          >
                            Save
                          </button>

                        <Link to='terms' className="btn btn-outline-dark">
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  
  export default TermsAddTab